import { useEffect, useRef, useState } from "react";

export const useInViewport = <T extends HTMLElement>() => {
    const ref = useRef<T | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.3, // hiện 30% là trigger
            }
        );

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return { ref, isVisible };
};